// Maps an href inside a blog post to the PostHog target_type / target_slug pair (D-16). Used by
// the shared link primitives so tracking lives in one place, never at call sites.
//
// `search` covers the end-of-post CTA to /stores (CLAUDE.md: every new CTA gets an event). It
// extends D-16's target_type set; plan 08 records it in POSTHOG-EVENT-MAP.

export type BlogTargetType = "store" | "category" | "blog" | "search";

export type BlogHrefTarget = { targetType: BlogTargetType; targetSlug: string | null };

const SLUG_ROUTES: Record<string, BlogTargetType> = {
  store: "store",
  category: "category",
  blog: "blog",
};

/**
 * Only root-relative internal paths classify. Absolute and protocol-relative URLs, hashes, mailto
 * and "/" return null (not tracked as an internal target).
 */
export const classifyBlogHref = (href: string): BlogHrefTarget | null => {
  if (!href || !href.startsWith("/") || href.startsWith("//")) return null;

  const path = href.split(/[?#]/)[0];
  if (path === "/stores" || path === "/stores/") return { targetType: "search", targetSlug: null };

  const match = /^\/([^/]+)\/([^/]+)\/?$/.exec(path);
  if (!match) return null;
  // Own-property check: "/constructor/x" must not resolve through Object.prototype.
  const targetType = Object.prototype.hasOwnProperty.call(SLUG_ROUTES, match[1])
    ? SLUG_ROUTES[match[1]]
    : undefined;
  if (!targetType) return null;
  try {
    return { targetType, targetSlug: decodeURIComponent(match[2]) };
  } catch {
    return null; // malformed percent-encoding
  }
};
